class ApiError extends Error {
  constructor (message: string, public response: Response) {
    super(message)
  }
}

export default ApiError
